<template>
	<div>
		<a-modal v-show='!ishand' id='warp_sim1' width='40rem' v-model="visible" on-ok="handleOk1"
			v-dragModal
			:dialog-style="{ top: (25 - (tableData.length*5>20?20:tableData.length*5))+'vh' }"
			@cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
			<div class='mark-file'>
				<div  v-html='"審&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;核"'
					style="background-color: #0c8b97;border-radius:  10px 10px 0 0;color: #fff;width: 38rem;margin: 1rem 1rem 0 1rem;text-align: center;">
				</div>
			</div>
			<div solt='title' style="position: relative;">
				<!-- <div style="position: absolute;top: 0;left: 0;background-color: red;">標題</div> -->
			</div>
			<div style="width: 38rem;" class='body_lis'>
				<div style="padding-top: 1.5rem;position: relative;left: -.5rem;">
					<a-form-model ref='form' :model="form" labelAlign='right' layout="inline" :rules='rules'
						hideRequiredMark v-if='aduit'>
						<div id='lastname'>
							<a-form-model-item prop='remark'>
								<div slot='label' v-html='"備&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;註"'
								 style="display: inline-block;color: #000000;"></div>
								<a-textarea v-model="form.remark" placeholder=" " :auto-size="{ minRows: 3, maxRows: 5 }"
									/>
							</a-form-model-item>
						</div>
					</a-form-model>
					<a-row v-if='tableData.length'>
						<div class='mydivs' :style="{maxHeight: aduit?'11rem':'18rem'}">
							<div v-for='(item,ind) in tableData'>
								<div class="c">
									<div>
										<span >{{item.admin}}</span>　:　
										<!-- handle 审核状态 0 提交 1  通过 2 拒绝 -->
										<span v-if='item.handle == 0'>{{item.status}}</span>
										<span v-else-if='item.handle == 1'>{{item.status}}</span>
										<!--  style="color: #3bc7a1;"  style='color: #ed4853;'-->
										<span v-else-if='item.handle == 2'>{{item.status}}</span>
									</div>
									<div>{{ item.createdate }}</div>
								</div>
								<div class="c" v-if='item.remark'>{{ item.remark }}</div>
								<div class='t' v-if='ind !== tableData.length-1'></div>
							</div>
						</div>
					</a-row>
					<div v-if='aduit'>
						<div class="tableBzViewBtnView">
							<a-popconfirm title="確認審批通過？" @visibleChange="visibleShow(record,'1')"
								v-model="popconfirm1Bol" ok-text="確定" cancel-text="取消"
								@confirm="shTgEvent(record,1)"
								:getPopupContainer="triggerNode => {return triggerNode.parentNode;}">
								<a-icon slot="icon" type="question-circle-o" style="display: none;" />
								<a-button @click="ifClickBtn = true" class="tableBzViewBtn"
									style="background-color:#3bc7a1;">
									{{record.shKhadmin1Bol ? '已處理' :'審核通過'}}
								</a-button>
							</a-popconfirm>
							<a-popconfirm v-if="!record.shKhadmin1Bol" title="拒絕審批通過？"
								@visibleChange="visibleShow(record,'2')" v-model="popconfirm2Bol"
								ok-text="確定" cancel-text="取消" @confirm="shTgEvent(record,2)"
								:getPopupContainer="triggerNode => {return triggerNode.parentNode;}">
								<a-icon slot="icon" type="question-circle-o" style="display: none;" />
								<a-button @click="ifClickBtn = true" class="tableBzViewBtn"
									style="background-color:#ed4849;">審核拒絕</a-button>
							</a-popconfirm>
						</div>
					</div>
				</div>
			</div>
			<div style="width: 100%;height: 1px;"></div>
		</a-modal>
	</div>
</template>

<script>
	import App from '@/assets/app.js';
	export default {
		props: ['record'],
		data() {
			return {
				ishand: false,
				visible: true,
				popconfirm3Bol: false,
				popconfirm2Bol: false,
				popconfirm1Bol: false,
				rules: {
					domainname_address:[{required:true,message:' ',trigger:'blur'}],
					register_date:[{required:true,message:' ',trigger:'change'}],
					expire_date:[{required:true,message:' ',trigger:'change'}],
					domainname_type:[{required:true,message:' ',trigger:'change'}],
					ip:[{required:true,message:' ',trigger:'blur'}],
					supplier:[{required:true,message:' ',trigger:'blur'}],
				},
				tableData:[],
				aduit:false,
				form: {
					 "domainname_address":"", //域名地址
					 "supplier":"",                  //供應商
					 "ip":"",            //域名綁定ip
					 "register_date":"", //註冊日期
					 "expire_date":"",  //到期日期
					 "domainname_type":"",  //域名類型
					 "remark":"", //備註
					 otherSystemManagementLogList:[]
				},
			}
		},
		mounted() {
				this.getdata()
		},
		methods: {
			visibleShow(record, type) {},
			getdata() {
				this.$ajax({
					method: 'post',
					url: this.$api.getAttenceApplyAuditLogList,
					data: {
						"applyid": this.record.applyid,
						token: this.$store.state.token
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						this.tableData = res.data.applyAduitLogList;
						this.aduit = res.data.aduit;
					}
				})
			},
			handleCancel(ev) {
				this.$emit('child', 0)
			},
			shTgEvent(record, type) { //1通過  //2拒絕
			 if(this.record.readingflag !== 1){
				App.oTool.warningT('請先查看PDF');
				return
			}
				if (!this.form.remark) {
					if (type == 1) {
						this.form.remark = '審核通過'
					} else if (type == 2) {
						App.oTool.warningT('請填寫備註信息');
						return
					}
				}
			
				this.$ajax({
					method: 'post',
					url: this.$api.newAttenceApplyAudit,
					data: {
						"applyid": this.record.applyid,
						token: this.$store.state.token,
						 "handle":type, //1 審核通過 2審核拒絕
						 "remark":this.form.remark  //備註
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						App.oTool.successT();
						this.$emit('child', true);
						this.shShowBol = false;
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				})
			},
			handleOk1() {

			}
		}
	}
</script>

<style lang="scss">
	#warp_sim1 .ant-modal-header,
	#warp_sim1 .ant-modal-body {
		background-color: #e5e5e5 !important;
		padding: 1rem;
		padding-top: 0.7rem;
	}

	#warp_sim1 {
		.tableBzViewBtnView{text-align: center;}
		.tableBzViewBtn {
			margin: 0 3rem !important;
			color: #fff;
		}
		.ant-form-explain{
			display: none;
		}

		.ant-col-12 {
			text-align: right;
		}

		.ant-form-item-label {
			width: 30%;
		}
		.ant-form-item, .ant-form-item-control{
			width: 100%;
			.ant-calendar-picker{
				width: 100%;
			}
			
		}
		
		.ant-form-item-control-wrapper{
			width:70%;
			.ant-form-item-control{
				width: 100%;
			}
		}
		#lastname{
			.ant-form-item-label{
				width: 15%;
			}
			.ant-form-item-control-wrapper{
				width: 85%;
				textarea{
					width: 100%;
				}
			}
		}
		.ant-form-inline .ant-form-item {
			margin-right: 0;
		}

		.warp-right {
			text-align: right;
		}

		.ant-modal-content {
			border-radius: 10px;
		}

		.ant-form-item {
			margin-bottom: 1rem;
		}

		.ant-form-item label {
			font-size: .8rem !important;
		}

		.ant-input {
			font-size: .8rem !important;
		}

		.ant-select-selection-selected-value {
			font-size: .8rem !important;
		}

		.ant-form-item-children {
			font-size: .8rem !important;
		}

		.mydivs {
			overflow-y: auto;
			// margin-bottom: 1rem;
			padding: 1rem;
			margin-left: 4%;
			width: 96%;
			background-color: #f5f5f5;
			margin-bottom: 1rem;
		
			.c {
				font-size: .8rem;
				margin: .2rem 0;
				display: flex;
				justify-content: space-between;
			}
		
			.t {
				margin: .5rem 0;
				border-bottom: 1px solid #d9d9d9;
			}
		}

		.ant-modal-body {
			padding: 0;
			padding-top: 2.5rem;
		}

		.btn1 {
			cursor: pointer;
			width: 8rem;
			height: 2rem;
			font-size: .8rem;
			color: #fff;
			border: 0;
			border-radius: 5px;
			margin: 0 3rem;
		}

		.btnx {
			background-color: #0c8b97;
		}

		.btn2 {
			background-color: #999999;
		}
	}
</style>
